import React from 'react'

function PrivacyPolicy() {
  return (
    <div className="container mt-4 mt-lg-5">
      <h4>Privacy Policy</h4>
      <p>
        At <strong>EthiocarHub</strong>, your privacy is very important to us. 
        This Privacy Policy explains how we collect, use, and protect your personal data 
        when you use our website.
      </p>
      <p>
        We only collect information necessary to provide our services such as car listings, 
        contact details for communication, and analytics to improve the platform.
      </p>
      <p>
        By using our website, you agree to the terms outlined in this policy.
      </p>
    </div>
  )
}

export default PrivacyPolicy;









